import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

export default function AffiliateDisclosure() {
  const effective = new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="mx-auto max-w-3xl px-4 py-6 sm:py-10">
      <Card className="elevated-card">
        <CardHeader>
          <CardTitle className="text-slate-900 dark:text-slate-100">Affiliate Disclosure</CardTitle>
        </CardHeader>
        <CardContent className="space-y-5 text-slate-700 dark:text-slate-300">
          <div className="text-sm text-slate-500">Last updated: {effective}</div>

          <section className="space-y-3">
            <p>
              This website may contain affiliate links. This means that if you click on a link and make a purchase, I may
              earn a commission — at no additional cost to you.
            </p>
            <p>
              I only recommend products or services that I believe may add value to my visitors. However, please
              understand that any purchase decision is entirely yours, and I encourage you to do your own research before
              buying.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Why am I disclosing this?</h2>
            <p>
              The FTC in the United States and consumer protection laws in the EU/UK require transparency whenever a
              website owner has a financial relationship with a merchant. This disclosure ensures that you know I may
              receive compensation, which helps support the cost of running this website.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">What does this mean for you?</h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>Clicking on an affiliate link and making a purchase may result in me earning a commission.</li>
              <li>The price you pay is exactly the same as if you visited the merchant’s site directly.</li>
              <li>Affiliate partnerships do not influence the content, reviews, or recommendations published on this site.</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="font-semibold text-slate-900 dark:text-slate-100">Final note</h2>
            <p>
              I value honesty and transparency with my readers. If you have any questions about affiliate links on this
              site, please feel free to contact me.
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}